export const adaptFrecuenciaDisponible = (frecuenciaProfesionalData) => {
    return {
        id: frecuenciaProfesionalData?.idFrecuenciaProfesional,
        displayName: frecuenciaProfesionalData?.descripccion,
        name: frecuenciaProfesionalData?.descripccion
    }
}

export const adaptFrecuenciaDisponibleArray = (
    frecuenciaProfesionales
) => {
    return structuredClone(frecuenciaProfesionales?.frecuenciasDisponibles)
        ?.map(frecuenciaProfesional => adaptFrecuenciaDisponible(frecuenciaProfesional));
}